import "./ArrowButton.css";

const NoButton = ({ isOpen, color, isSelected }) => (
    <button
        className={`arrow-btn ${isOpen ? "open" : ""}`}
        style={{
            backgroundColor: isSelected ? "var(--colorFront)" : color,
            color: isSelected ? "var(--colorBack)" : "var(--colorFront)",
            borderColor: "var(--colorFront)",
        }}
    >

    </button>
);

export default NoButton;